

import "./style/style2.css"


import Footer from './Footer';

import YBlogo from './images/Yacin-Benziane-Logo.png'
import me from '../assets/yacine-dev-circle.png'
import FlagFr from './images/flag-fr.svg'
import FlagUS from './images/flag-us.svg'
import FlagDeutsch from './images/flag-Deutsch.svg'

import { Link, Route, Routes } from 'react-router-dom';

import { useState } from 'react';

import { useLenis } from '@studio-freight/react-lenis'

import { motion } from 'framer-motion';
import ScrollToTop from './ScrollToTop';

import copyIcon from './images/copy.svg'
import arrowIcon from './images/arrow.svg'


export default function About() {

    const [TextOpacity, setTextOpacity] = useState('.0');
    const [TextPos, setTextPos] = useState('77px');

    const lenis = useLenis(({ scroll }) => {
        // called every scroll
    })

    function timeout(delay: number) {
        return new Promise(res => setTimeout(res, delay));
    }

    const handleCopyEmail = async () => {


        // Copy the text inside the text field

        var tempInput = document.createElement('input');
        tempInput.value = "benzianeoyacine@gmail.com";
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        // Alert the copied text

        setTextOpacity('0');
        setTextPos('77px');
        await timeout(100); //for 1 sec delay

        setTextOpacity('.3');
        setTextPos('0px');

    }
    const handleCopyPhone = async () => {
        // Copy the text inside the text field
        var tempInput = document.createElement('input');
        tempInput.value = "+49 176 595 324 46";
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        setTextOpacity('0');
        setTextPos('77px');

        await timeout(100); //for 1 sec delay

        setTextOpacity('.3');
        setTextPos('0px');

    }



    const handleCopyLinkedin = async () => {
        // Copy the text inside the text field
        var tempInput = document.createElement('input');
        tempInput.value = "https://www.linkedin.com/in/yacineb/";
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        setTextOpacity('0');
        setTextPos('77px');

        await timeout(100); //for 1 sec delay

        setTextOpacity('.3');
        setTextPos('0px');

    }

    return (
        <ScrollToTop>

            <motion.div class='rootBody' initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 1 }} transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }} >

                <div class="homePage" id="home">
                    <div class="menu">
                        <div class="siteName"><Link to="/" style={{ 'text-decoration': 'none' }}><img src={YBlogo} /></Link></div>
                        <div class="menuLinks">

                            <a href='/#projects' class="link">Work</a>
                            <Link to="/about" style={{ 'text-decoration': 'none' }}><div class="link">About</div></Link>
                            <Link to="/contact" style={{ 'text-decoration': 'none' }}><div class="link">Contact</div></Link>

                            {/* EN | FR */}

                        </div>


                    </div>

                    <div class="aboutSection" >

                        <div class="aboutLeft" >
                            <img src={me} style={{ borderRadius: '13px', width: '100%', borderRadius: '23px', border: 'solid 0.5px #ccc', marginTop: '-17px'}} />
                        </div>

                        <div class="aboutRight">


                            <p style={{ 'line-height': '31px' }}>I'm Yacine, a Fullstack Developer with over 5 years of experience. I'm specialized in Frontend development, mainly within the React ecosystem. I also have a strong background in UX UI design.

                                <p />I have collaborated with teams in various stages of product delivery, from creating software from scratch to scaling up features, delivering intuitive solutions.

                                <p />
                                <p />Also, I speak both English <img src={FlagUS} style={{ height: '15px', transform: 'translateY(0px) rotate(13deg)', borderRadius: '3px' }} /> and French <img src={FlagFr} style={{ height: '21px', transform: 'translateY(3px) rotate(13deg', 'shape-rendering': 'optimizeQuality' }} /> fluently, and a bit of German <img src={FlagDeutsch} style={{ height: '21px', transform: 'translateY(3px) rotate(13deg' }} /> :).

                                <p><span style={{ fontSize: '21px' }}>📍</span>Currently living in Frankfurt, Germany</p>



                            </p>

                        </div>
                    </div>


                    <div class="aboutSkills">

                        <div class="skills" >

                            <div class="skillsTitle"><h2>Skills</h2></div>
                            <p style={{ 'line-height': '31px' }}>
                                UX UI Design, CSS, JavaScript, React, TypeScript, Node.js, Next.js, Tanstack, Vue.js, CI/CD, Figma, Git, Jest, SQL, Postgres, Supabase, Docker, Python, Phaser, Motion Design.                                </p>
                        </div>
                        <div class="skills">


                            <div class="skillsTitle"><h2>Tools</h2></div>

                            <p>
                                VS Code, GitHub, Chrome DevTools, Figma, Miro, Hotjar, Adobe Creative Suite.
                            </p>
                        </div>

                        <div class="skills">
                            <div class="skillsTitle"><h2>Hobbies</h2></div>

                            <p>
                                Basketball,
                                board games,
                                long walks, game dev...
                            </p>
                        </div>

                        <div class="skills">

                        </div>

                    </div>


                    <div class='contactSection' style={{ width: '100%', 'min-height': '311px', 'height': '0px', 'padding': '71px 0 77px 0', gap: '37px', 'background-color': '#ffffff' }}>

                        <div class="heroText" id="letsCon" style={{ width: 'auto', padding: '0px 0 0 0' }}>Let's connect and grab a coffee !</div>

                        <div id="letsCon" style={{ 'font-size': '24px', 'font-weight': '600', 'opacity': TextOpacity, transition: 'opacity, transform 200ms ease-out', margin: '-29px', transform: 'translateY(' + TextPos + ')' }}> Copied !</div>
                        <div>



                            <div class='pill'>
                                <div class="pillContent">+49&nbsp;176&nbsp;595&nbsp;324&nbsp;46</div>
                                <div class="pillBtn" style={{ display: 'flex' }}>
                                    <div class='iconCircle' onClick={handleCopyPhone}><img src={copyIcon} /></div>
                                    <div class='iconCircle' id="emailAwrow"><a href="tel:+4917659532446"><img src={arrowIcon} style={{ margin: '-5px' }} /></a></div>
                                </div>
                            </div>



                            <div class='pill'>
                                <div class="pillContent">benzianeoyacine@gmail.com</div>

                                <div class="pillBtn" style={{ display: 'flex' }}>
                                    <div class='iconCircle' onClick={handleCopyEmail}><img src={copyIcon} /></div>
                                    <div class='iconCircle' id="emailAwrow"><a href="mailto:benzianeoyacine@gmail.com"><img src={arrowIcon} style={{ margin: '-5px' }} /></a></div>
                                </div>
                            </div>



                            <div class='pill'  >
                                <div class="pillContent" >linkedin/in/yacineb</div>

                                <div class="pillBtn" style={{ display: 'flex' }}>
                                    <div class='iconCircle' onClick={handleCopyLinkedin}><img src={copyIcon} /></div>
                                    <div class='iconCircle' id="emailAwrow"><a href="https://www.linkedin.com/in/yacineb/" target="_blank"><img src={arrowIcon} style={{ margin: '-5px' }} /></a></div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <Footer />

                </div>

            </motion.div>

        </ScrollToTop>

    )
}